<app-my-navbar></app-my-navbar>


<router-outlet></router-outlet>